import {useState, useEffect} from 'react';
import { updateQuantity } from '../business/Order';
import { useOrderContext } from '../OrderContext';

export const CalculateModal = ({data}) =>{
    const {orders, setOrders} = useOrderContext();
    const {orderId, dishId, quantity} = data;
    const [isOpen, setModalStatus] = useState(true)
    const [newQuantity, setNewQuantity] = useState(quantity);
    
    useEffect(() => {
            setNewQuantity(quantity);
    }, [quantity])

    useEffect(() => {
        const handleClick = (event) => {

            const modal = document.getElementById('calculateModal');
            const modalDialog = document.querySelector('.modal-dialog.calc-modal');

            if (!modalDialog.contains(event.target) && modal === event.target) {
                setModalStatus(true);
            }
        };
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, []);

    const handleCalcBtn = (value) => {
        if (value === 'del') {
            if (newQuantity !== undefined && newQuantity !== "") {
                setNewQuantity(prevQty => prevQty.slice(0, -1));
            }
        } else if (value === 'clear') {
            setNewQuantity("");
        }  else if (value === 'enter') {
            const number = parseFloat(newQuantity).toFixed(3);
            if (!isNaN(number) && number !== quantity) {
                updateQuantity(orders, setOrders, {orderId: orderId, dishId: dishId, quantity: number})
            }
            else{
                setNewQuantity(quantity)
            }
            setModalStatus(true)
        } else if (value === 'close') {
            setModalStatus(true);
            setNewQuantity("");
            setNewQuantity(quantity);
        } else {
            if (isOpen){
                setModalStatus(false);
                setNewQuantity(value);
            }
            else {
                setNewQuantity(prevQty => prevQty + value);
            } 
        }
    }

    return (
        <div className="modal fade" id="calculateModal">
            <div className="modal-dialog calc-modal">
                <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">Кількість</h1>
                    <button type="button" className="btn-close" onClick={() => handleCalcBtn('close')} data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div className="modal-body">
                    <div className="row mb-3">
                        <div className="col">
                            <div className="form-group">
                                <input type="email" className="form-control" 
                                value={newQuantity} id="сalc-input"
                                readOnly/>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-1">
                        <div className="col"><button onClick={() => handleCalcBtn('7')} className="btn btn-secondary" >7</button></div>
                        <div className="col"><button onClick={() => handleCalcBtn('8')} className="btn btn-secondary" >8</button></div>
                        <div className="col"><button onClick={() => handleCalcBtn('9')} className="btn btn-secondary" >9</button></div>
                        <div className="col-3"><button onClick={() => handleCalcBtn('del')} className="btn btn-secondary" > Видалити </button></div>
                    </div>
                    <div className="row mb-1">
                        <div className="col"><button onClick={() => handleCalcBtn('4')} className="btn btn-secondary" >4</button></div>
                        <div className="col"><button onClick={() => handleCalcBtn('5')} className="btn btn-secondary" >5</button></div>
                        <div className="col"><button onClick={() => handleCalcBtn('6')} className="btn btn-secondary" >6</button></div>
                        <div className="col-3"><button onClick={() => handleCalcBtn('clear')} className="btn btn-secondary" >Відмінити</button></div>
                    </div>
                    <div className="row mb-1">
                        <div className="col"><button onClick={() => handleCalcBtn('1')} className="btn btn-secondary" >1</button></div>
                        <div className="col"><button onClick={() => handleCalcBtn('2')} className="btn btn-secondary" >2</button></div>
                        <div className="col"><button onClick={() => handleCalcBtn('3')} className="btn btn-secondary" >3</button></div>
                        <div className="col-3"></div>
                    </div>
                    <div className="row mb-1">
                        <div className="col"><button onClick={() => handleCalcBtn('0')} className="btn btn-secondary" >0</button></div>
                        <div className="col"><button onClick={() => handleCalcBtn('.')} className="btn btn-secondary" >.</button></div>
                        <div className="col-6"><button className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => handleCalcBtn('enter')}>Підтвердити</button></div>
                    </div>
                </div>
                <div className="modal-footer">
                    
                </div>
                </div>
            </div>
        </div>
    )
}
